import React from 'react';
import { isNil } from 'lodash';

import SeparatorBar from 'pages/product-full-view/components/product-media-area/nutrition-label/components/SeparatorBar';
import SupplementList from 'pages/product-full-view/components/product-media-area/supplement-label/SupplementList';
import {
  groupDataByPartOf,
  getSupplementMappingLevel,
  orderNutrientList,
} from 'pages/product-full-view/components/product-media-area/supplement-label/utils';
import {
  SUPPLEMENT_NUTRIENTS,
  SUPPLEMENT_NUTRIENT_NAME,
} from 'pages/product-full-view/components/product-media-area/nutrition-label/constants/index';
import { WrapperFactsPanel } from '../multiple-panel/facts-panel/overlay/WrapperNutrient';
import Calories from './Calories';

import './Supplement.less';
import { renderContainerDescriptor } from '../multiple-panel/components/utils';

const SupplementStandardLabel = ({
  label,
  compareValue,
  nutrients,
  dietaryIngredients,
}) => {
  const {
    servingSize,
    servingSizeMeasurement,
    servingSizeDescription,
    numberOfServingsPerContainer,
    fdaLabelFootNote,
    calories,
    caloriesFromFat,
    otherIngredients,
  } = label || {};

  const nutrientOrdered = orderNutrientList(
    nutrients ?? [],
    SUPPLEMENT_NUTRIENTS
  );
  const nutrientGrouping = groupDataByPartOf(
    nutrientOrdered,
    SUPPLEMENT_NUTRIENT_NAME.NUTRIENT
  );
  const nutrientGroupMappingKey = getSupplementMappingLevel(nutrientGrouping);

  const dietaryIngredientsGrouping = groupDataByPartOf(
    dietaryIngredients ?? [],
    SUPPLEMENT_NUTRIENT_NAME.INGREDIENT
  );
  const dietaryIngredientsGroupMappingKey = getSupplementMappingLevel(
    dietaryIngredientsGrouping
  );

  const servingPerContainerDescriptor = renderContainerDescriptor(
    label?.servingPerContainerDescriptor
  );

  return (
    <div className='supplement-standard'>
      <div className='supplement-standard__wrapper'>
        <h1 className='m-0 supplement-standard__label'>Supplement Facts</h1>
        <WrapperFactsPanel
          label={[
            'servingSize',
            'servingSizeMeasurement',
            'servingSizeDescription',
          ]}
          currentValue={label}
          originValue={compareValue}
        >
          <p className='m-0 supplement-standard__serving'>
            {servingPerContainerDescriptor ? (
              <span>{servingPerContainerDescriptor}&nbsp;</span>
            ) : null}
            {numberOfServingsPerContainer} servings per container
          </p>
        </WrapperFactsPanel>
        <WrapperFactsPanel
          label={['numberOfServingsPerContainer']}
          currentValue={label}
          originValue={compareValue}
        >
          <p className='m-0 supplement-standard__serving'>
            Servings Per Container: {numberOfServingsPerContainer}
          </p>
        </WrapperFactsPanel>
        <SeparatorBar height={8} />
        <div className='supplement-standard__heading'>
          <p className='m-0' style={{ marginLeft: 'auto' }}>
            Amount Per Serving
          </p>
          <p className='supplement-standard__heading-dv'>%Daily Value</p>
        </div>
        <SeparatorBar height={4} />
        <Calories
          label={label}
          calories={calories}
          compareValue={compareValue}
          caloriesFromFat={caloriesFromFat}
        />
        <SupplementList
          isSupplementWithoutDailyValue={false}
          data={nutrientGroupMappingKey}
        />
        {nutrientGroupMappingKey?.length || !isNil(calories) ? (
          <SeparatorBar height={8} />
        ) : null}
        <SupplementList
          isSupplementWithoutDailyValue={true}
          data={dietaryIngredientsGroupMappingKey}
        />
        {dietaryIngredientsGroupMappingKey?.length ? (
          <SeparatorBar height={8} marginTop={'-1px'} />
        ) : null}
        <WrapperFactsPanel
          label={['fdaLabelFootNote']}
          currentValue={label}
          originValue={compareValue}
        >
          <p
            className='supplement-standard__footnote'
            style={{
              whiteSpace: 'pre-line',
            }}
          >
            {fdaLabelFootNote}
          </p>
        </WrapperFactsPanel>
      </div>
      <WrapperFactsPanel
        label={['otherIngredients']}
        currentValue={label}
        originValue={compareValue}
      >
        {otherIngredients && (
          <p className='supplement-standard__other-ingredient'>
            <strong className='supplement-standard__other-ingredient-title'>
              Other Ingredients:
            </strong>
            <span className='supplement-standard__other-ingredient-text'>
              {otherIngredients}
            </span>
          </p>
        )}
      </WrapperFactsPanel>
    </div>
  );
};

export default SupplementStandardLabel;
